<template>
    <div class="add">
        <div class="parent" v-if="spin">
            <div class="block">
                <jumper class="spin"></jumper>
            </div>
        </div>
        <div class="spin">

        </div>

        <Questionnaire v-if="!spin" :sha256="sha256"></Questionnaire>
        <Report v-if="!spin"></Report>
    </div>
</template>
<script>
    import Questionnaire from '@/components/Questionnaire.vue'
    import Report from '@/components/Report.vue'
    import {Jumper} from 'vue-loading-spinner'


    export default {
        name: 'add',
        components: {Questionnaire, Report, Jumper},
        props: ['sha256'],
        data() {
            return {
                spin: true
            }
        },
        mounted() {
            if (this.sha256) {
                this.$store.dispatch('RECEIVED_DATA', this.sha256)
                    .then(result => {
                        setTimeout(() => {
                            this.spin = false;
                        }, 1500);

                    });
            } else {
                let templateNumber = this.$store.getters.TEMPLATE_NUMBER;
                this.$store.dispatch('SAVE_TEMPLATE', this.$route.query);
            }
        }
    }
</script>
<style scoped>
    .parent {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        overflow: auto;
    }

    .block {
        width: 250px;
        height: 250px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -125px 0 0 -125px;
    }

    .spin {
        max-width: 100%;
        height: auto;
        display: block;
        margin: 0 auto;
        border: none;
    }
</style>
